import { createSelector } from 'redux-starter-kit';

const reportSelector = (state: any) => state.report;

export const reportSelectors = {
  getImages: createSelector(reportSelector, subState => subState.images),
  getImagesLoading: createSelector(
    reportSelector,
    subState => subState.imagesLoading
  )
};
